<template>
  <div>
    <form
      v-if="!finished"
      class="w-3/4 flex flex-col mx-auto"
      novalidate
      @submit.prevent="submit"
    >
      <h2 class="mb-6 lg:text-grey-darkest font-medium lg:text-3xl">{{ pageTitle }}</h2>
      <p class="mb-6 text-orange font-bold">Не се допускат повторни регистрации със същия имейл или телефон.</p>
      <form-wrapper :validator="$v.form">
        <form-field name="first_name">
          <input
            slot-scope="{ attrs, validator }"
            v-model.trim="validator.$model"
            v-bind="attrs"
            type="text"
          >
        </form-field>
        <form-field name="last_name">
          <input
            slot-scope="{ attrs, validator }"
            v-model.trim="validator.$model"
            v-bind="attrs"
            type="text"
          >
        </form-field>
        <form-field name="email">
          <input
            slot-scope="{ attrs, validator }"
            v-model.trim="validator.$model"
            v-bind="attrs"
            type="email"
          >
        </form-field>
        <form-field name="email_confirm">
          <input
            slot-scope="{ attrs, validator }"
            v-model.trim="validator.$model"
            v-bind="attrs"
            type="email"
          >
        </form-field>
        <form-field name="phone">
          <phone-input
            slot-scope="{ attrs, validator }"
            v-model.trim="validator.$model"
            v-bind="attrs"
          />
        </form-field>
        <form-field name="password">
          <input
            slot-scope="{ attrs, validator }"
            v-model.trim="validator.$model"
            v-bind="attrs"
            type="password"
          >
        </form-field>
        <form-field
          :validator-params="{ eq:'Парола' }"
          name="password_confirmation"
        >
          <input
            slot-scope="{ attrs, validator }"
            v-model.trim="validator.$model"
            v-bind="attrs"
            type="password"
          >
        </form-field>
        <form-field
          name="over_18"
          class="border-b-0"
        >
          <label
            slot-scope="{ attrs, validator }"
            class="has-checkbox"
          >
            <input
              v-model="validator.$model"
              v-bind="attrs"
              type="checkbox"
            > Аз съм над 18 год.
          </label>
        </form-field>
        <label class="has-checkbox mb-6 inline-block">
          <i class="icon mps mps-lock text-orange" /> Не споделяме личните ви данни с трети лица за маркетингови цели.
        </label>
        <form-field
          name="terms"
          class="border-b-0"
        >
          <label
            slot-scope="{ attrs, validator }"
            class="has-checkbox"
          >
            <input
              v-model="validator.$model"
              v-bind="attrs"
              type="checkbox"
            >
            Запознах се с
            <router-link
              :to="{ name: 'terms' }"
              class="underline text-grey-dark"
            >
              условията за ползване на сайта
            </router-link>
            и ги приемам.
          </label>
        </form-field>
      </form-wrapper>
      <div class="text-center">
        <v-button
          :loading="form.isLoading"
          color="is-dark-red"
          full
        >
          Регистрация
        </v-button>
        <template v-if="false">
          <div class="my-4">или</div>
          <div class="flex flex-wrap justify-center -mx-2">
            <div class="px-2 xsm:flex-none flex-1 xsm:w-auto w-full mb-4">
              <v-button
                class="sm:icon-only"
                color="is-red"
                full
                icon="google"
              >
                Google
              </v-button>
            </div>
            <div class="px-2 xsm:flex-none flex-1 xsm:w-auto w-full mb-4">
              <v-button
                class="sm:icon-only"
                color="is-facebook"
                full
                icon="facebook"
              >
                Facebook
              </v-button>
            </div>
          </div>
        </template>
      </div>
      <div class="flex justify-around text-xs underline mt-6">
        <router-link :to="{ name: 'login', query: $route.query }">Вече съм регистриран</router-link>
        <router-link :to="{ name: 'forgotten-password', query: $route.query }">Забравена парола?</router-link>
      </div>
    </form>
    <div
      v-else
      class="px-2 text-center leading-normal"
    >
      <h2 class="mb-6 lg:text-grey-darkest font-medium lg:text-3xl"> Потвърди регистрацията си. </h2>
      <div class="mb-4">Изпратили сме ти линк за активация на <strong class="text-red">{{ form.email }}</strong>.</div>
      <div class="text-xl my-6">Непотвърдени акаунти, <strong class="text-orange lg:text-red">НЕ УЧАСТВАТ</strong>
        в туровете и се изтриват автоматично до 72 часа.
      </div>
      <div class="text-orange mb-4">
        <v-icon
          type="envelope"
          size="4x"
        />
      </div>
      <div class="lg:text-grey leading-normal">
        Ако не получиш имейл до няколко минути, моля свържи се с нас на
        тел: <a class="underline" href="tel:+359 877 222 359">+359 877 222 359</a>,
        имейл: <a class="underline" href="mailto: contact@mpsexpert.bg"> contact@mpsexpert.bg</a>
        или през <router-link :to="{ name: 'contact' }" class="underline">контактната ни форма</router-link>.
      </div>
    </div>
  </div>
</template>
<script>
import { Form } from '@/services/Form'
import { required, sameAs, email, minLength, helpers } from 'vuelidate/lib/validators'
import { AuthApiService } from '@/services/api/AuthApiService'
import PhoneInput from '@/components/core/PhoneInput'

const form = () => new Form({
  first_name: { value: '', rules: { required } },
  last_name: { value: '', rules: { required } },
  email: { value: '', rules: { required, email } },
  email_confirm: { value: '', rules: { required, email, sameAs: sameAs('email') } },
  phone: { value: '', rules: { required, phone: helpers.regex('phone', /^\+359\d{9}$/i) } },
  password: { value: '', rules: { required, minLength: minLength(6) } },
  password_confirmation: { value: '', rules: { required, sameAs: sameAs('password') } },
  over_18: { value: false, rules: { checked: v => v === true } },
  terms: { value: false, rules: { checked: v => v === true } }
})

const minimumThreshold = 7000 // 7 secs

export default {
  name: 'Register',
  components: { PhoneInput },
  props: {
    pageTitle: {
      type: String,
      default: 'Регистрация'
    }
  },
  data () {
    return {
      form: form(),
      finished: false
    }
  },
  validations () {
    return {
      form: this.form.rules()
    }
  },
  computed: {
    isUsingABV () {
      return this.form.email.match(/.*@abv\.bg$/)
    },
    warningEmailMessage ({ isUsingABV }) {
      const mainWarning = `<p class="mb-4">Провери дали имейла, с който се регистрираш <b>"${this.form.email}"</b> е валиден. Ако нямаш достъп до него,
          <span class="text-red font-bold">не можеш</span> да използваш платформата МПС Ескперт.</p>`

      return isUsingABV
        ? `${mainWarning} <p class="mb-4">Обръщаме <span class="text-orange font-bold">специално</span> внимание защото ползваш услугите на <b>ABV.BG</b>!
          Имейлите им се <span class="text-red font-bold">деактивират</span> при повече от 180 дена без вход.</p>`
        : mainWarning
    }
  },
  methods: {
    async submit () {
      try {
        this.$v.form.$touch()
        if (this.$v.$error) return
        const firedAt = Date.now()
        const result = await this.$notify.fire({
          title: '<span class="text-red">Внимание!</span>',
          html: this.warningEmailMessage,
          confirmButtonText: 'Имейлът е активен',
          cancelButtonText: 'Не знам',
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showLoaderOnConfirm: true,
          preConfirm: () => {
            const now = Date.now()
            const elapsedMs = now - firedAt // the time that has passed
            const difference = minimumThreshold - elapsedMs // how much time is left

            if (elapsedMs < minimumThreshold) {
              this.$notify.Swal.showValidationMessage('Моля прочетете съобщението!')
              return new Promise((resolve) => {
                setTimeout(resolve, difference)
              })
            }
            return true
          }
        })
        if (result.dismiss === this.$notify.Swal.DismissReason.cancel) {
          return this.$notify.info('Ако не си сигурен, провери дали имейла ти е валиден, активен и има място.')
        }
        if (!result.value) return
        await this.form.submit(AuthApiService.register)
        this.finished = true
        // Tracking codes
        this.$ma.trackEvent({ category: 'Account', action: 'NewAccount', label: this.form.email }, ['facebook'])

        window.fbq('trackCustom', 'NewAccount', {
          type: 'Registered',
          userEmail: this.form.email,
          userName: `${this.form.first_name} ${this.form.last_name}`
        })
      } catch (err) {
        this.$displayError(err)
      }
    }
  }
}
</script>
